export default (amountFunded, amountPledged) => {
  if ((amountFunded === null || amountFunded === 0) && amountPledged > 0) {
    return 'Pledged';
  }
  return 'Funded';
};
